// Modules
import React from 'react'

// Application
import { useActivateHook } from 'hooks'

// Components
import { NewPassword, NewPasswordInitial } from 'components/Presenters/NewPassword'

export const NewPasswordWrapper: React.VFC = () => {
    const { setPassword, nextStep, moveToError } = useActivateHook()

    const handleSubmit = async ({ password }: NewPasswordInitial) => {
        try {
            await setPassword(password)
            nextStep()
        } catch {
            moveToError('/erro-de-conexao')
        }
    }

    return <NewPassword handleSubmit={handleSubmit} initialValues={{ password: '', confirmPassword: '' }} />
}
